/*
 * FAQ
 */

(function ($) {

    var faq_list = $('.faq_list');
    if (faq_list.length > 0) {
        faq_list.find('dl').on('click', function () {
            $(this).toggleClass('_expanded');
            $(this).find('dd').slideToggle(300);
        });
    }

})(jQuery);